import React, { useState, useEffect } from "react";

import { useFormikContext } from "formik";
import { Delete } from "icons";

import multiSourceExceptionProfilingReportApi from "apis/MultiSourceExceptionProfilingReport";
import { Select } from "clearsense-ui/components/formik";

import { formatColumnForFilter, isColumnDynamicHeader } from "../utils";

const ConditionBlock = ({
  idx,
  state,
  arrayHelpers,
  columnOptions,
  deleteFilterCondition,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [valueOptions, setValueOptions] = useState([]);

  const formik = useFormikContext();

  const fetchColumnValues = async (selectedOption = {}) => {
    try {
      setIsLoading(true);
      const optionPath = Object.keys(selectedOption).length
        ? selectedOption
        : formik.values?.conditions?.[idx]?.column;
      const columnName = isColumnDynamicHeader(optionPath?.label)
        ? "context_value"
        : formatColumnForFilter(optionPath?.value);
      const res =
        await multiSourceExceptionProfilingReportApi.get_unique_column_values(
          state?.selectedCde?.label,
          columnName
        );
      setValueOptions(res.data.values);
    } catch (err) {
      logger.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    formik.values?.conditions?.[idx]?.column && fetchColumnValues();
  }, []);

  return (
    <div className="flex items-start gap-2 p-2 bg-grey-blue">
      <Select
        strategy="fixed"
        placeholder="Select column to filter"
        size="small"
        name={`conditions.${idx}.column`}
        className="w-5/12"
        options={columnOptions}
        onChange={selectedOption => {
          formik.setFieldValue(`conditions.${idx}.column`, selectedOption);
          formik.setFieldValue(`conditions.${idx}.value`, "");
          fetchColumnValues(selectedOption);
        }}
      />
      <Select
        isMulti
        strategy="fixed"
        placeholder="Select value to filter"
        size="small"
        name={`conditions.${idx}.value`}
        className="w-5/12"
        isLoading={isLoading}
        options={valueOptions.map(value => ({ label: value, value }))}
      />
      <div className="flex justify-center items-center">
        <Delete
          className="cursor-pointer text-danger"
          onClick={() => deleteFilterCondition(arrayHelpers, idx)}
        />
      </div>
    </div>
  );
};

export default ConditionBlock;
